module.exports = __webpack_public_path__ + "static/media/home.a1e3b653.png";